





















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  VodPageAction,
  VodPageGetter,
  VodPageMutation,
  VoDType
} from "@/components/VoD/types";
import DateTimeSection from "@/components/DateTimeSection.vue";
import Swiper, { SwiperOptions } from "swiper";
import SpatialNavigation from "spatial-navigation-js";
import {
  arrowKeysPreventDefault,
  debounce,
  getBreakpoint,
  MediaQuery,
  scrollToPage
} from "@/helpers/utils";
import { Action, Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { LocaleVodPageTypes } from "@/plugins/i18n/types";
import { Movie, TvShow, VoDGenre } from "@/services/apiService/api.types";
import apiStorageInterface from "@/services/apiStorageInterface";
import VoDCard from "@/components/VoD/component/VoDCard.vue";
import VodHome from "@/components/VoD/component/VoDHome.vue";
import VoDInfoModal from "@/components/VoD/component/VoDInfoModal.vue";
import { EventBus } from "@/main";
import SearchIcon from "@/assets/svg/svg-home/08-search.vue";

@Component({
  components: {
    DateTimeSection,
    "vod-card": VoDCard,
    VodHome,
    "vod-info-modal": VoDInfoModal,
    SearchIcon
  }
})
export default class VoDPage extends Vue {
  @Action(VodPageAction.UpdateTvShowsByGenre, {
    namespace: Namespace.Vod
  })
  updateTvShowsByGenre!: () => void;

  @Action(VodPageAction.UpdateMoviesByGenre, {
    namespace: Namespace.Vod
  })
  updateMoviesByGenre!: () => void;

  @Mutation(VodPageMutation.setViewedVodType, { namespace: Namespace.Vod })
  setViewedVodType!: (vodType: VoDType) => void;

  @Getter(VodPageGetter.GetViewedVodType, {
    namespace: Namespace.Vod
  })
  getViewedVodType!: VoDType;

  @Getter(VodPageGetter.GetViewedVodIndex, {
    namespace: Namespace.Vod
  })
  getViewedVodIndex?: number;

  @Getter(VodPageGetter.GetTvShowsByGenre, {
    namespace: Namespace.Vod
  })
  getTvShowsByGenre!: VoDGenre[];

  @Getter(VodPageGetter.GetMoviesByGenre, {
    namespace: Namespace.Vod
  })
  getMoviesByGenre!: VoDGenre[];

  @Getter(VodPageGetter.GetShowVodInfoModal, {
    namespace: Namespace.Vod
  })
  getShowVodInfoModal!: boolean;

  @Getter(VodPageGetter.GetInfoModalVodId, {
    namespace: Namespace.Vod
  })
  getInfoModalVodId!: number;

  vodType = VoDType;

  genreSwiper: Swiper | undefined;

  swiperOptions: SwiperOptions = {
    slidesPerView: 5,
    spaceBetween: 40
  };

  activeSlideIndex = 0;
  cardsToRender = 15;
  cardsPerRow = 0;

  searchFocused = false;
  searchfilter = "";

  handleResizeDebounce: () => void = debounce(this.setCardsPerRow, 50);
  handleSpatialNavDebounce: () => void = debounce(SpatialNavigation.resume, 50);
  scrollFuncRef = scrollToPage;

  LocaleVodPageTypes = LocaleVodPageTypes;

  filteredVodGenres: Array<string> = ["Home"];

  resizeObserver: ResizeObserver | null = null;
  paddingRight = 15;

  async mounted(): Promise<void> {
    this.updateTvShowsByGenre();
    this.updateMoviesByGenre();
    await Promise.all([
      this.getFilteredVodGenres(),
      apiStorageInterface.fetchFavoriteMovies(),
      apiStorageInterface.fetchFavoriteTvShows()
    ]);

    this.$nextTick(() => {
      this.genreSwiper = new Swiper(".swiper", this.swiperOptions);

      //needed for registering clicks on swiper elements
      this.genreSwiper.on("click", this.focusGenre);

      //making sure no accidental sliding happens
      this.genreSwiper.keyboard?.disable();
    });

    window.addEventListener("resize", this.handleResizeDebounce);

    if (document.getElementById("vodContainer")) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      document
        .getElementById("vodContainer")
        .addEventListener("scroll", this.scrollLazyLoad);
    }

    this.setCardsPerRow(); //setting initial value
    this.focusGenre(); //focusing genre of selected vod content if it is set

    // calculating minimum amount of cards to render or the viewed VoD card to appear
    if (this.getViewedVodIndex) {
      const remainder = this.getViewedVodIndex % 15;
      let wholeNum = Math.floor(this.getViewedVodIndex / 15);

      if (wholeNum !== 0) {
        this.cardsToRender = wholeNum * 15;
      }
      if (wholeNum !== 0 && remainder) {
        this.cardsToRender = (wholeNum + 1) * 15;
      }
    }

    EventBus.$on("VodFavUpdate", async () => {
      await this.getFilteredVodGenres();
    });
    EventBus.$on("cantRefocus", () => {
      //since there are many configurations of the VoD page we grab all rendered VoD cards and focus on the first one
      const firstAvailable = document.getElementsByClassName(
        "card vod_card focusable"
      )[0].id;
      SpatialNavigation.focus("#" + firstAvailable);
    });

    this.resizeObserver = new ResizeObserver((entries) =>
      entries[0].target.scrollHeight > entries[0].target.clientHeight
        ? (this.paddingRight = 5)
        : (this.paddingRight = 15)
    );
    this.resizeObserver.observe(document.getElementById("vodContainer")!);
    SpatialNavigation.resume();
  }

  //for focusing a specific genre on click or when refocusing played channels
  focusGenre(): void {
    const oldActiveSlideIndex = this.activeSlideIndex;
    //for compatibility with the click handler and vod refocus logic
    let desiredSlideIndex = this.genreSwiper?.clickedIndex
      ? this.genreSwiper.clickedIndex
      : 0;

    if (oldActiveSlideIndex < desiredSlideIndex) {
      for (let i = 0; i < desiredSlideIndex - oldActiveSlideIndex; i++) {
        this.slideRight();
      }
    }
    if (oldActiveSlideIndex > desiredSlideIndex) {
      for (let i = 0; i < oldActiveSlideIndex - desiredSlideIndex; i++) {
        this.slideLeft();
      }
    }
  }

  slideRight(): void {
    if (
      this.activeSlideIndex >= 2 &&
      this.activeSlideIndex <= this.filteredVodGenres.length - 3
    ) {
      this.genreSwiper?.slideNext();
    }

    if (this.activeSlideIndex < this.filteredVodGenres.length - 1)
      this.activeSlideIndex++;
    this.cardsToRender = 15;
    SpatialNavigation.focus("#id" + this.activeSlideIndex);
  }

  slideLeft(): void {
    if (
      this.activeSlideIndex >= 2 &&
      this.activeSlideIndex <= this.filteredVodGenres.length
    ) {
      this.genreSwiper?.slidePrev();
    }

    if (this.activeSlideIndex > 0) this.activeSlideIndex--;
    this.cardsToRender = 15;
    SpatialNavigation.pause();
    SpatialNavigation.focus("#id" + this.activeSlideIndex);
  }

  setCardsPerRow(): void {
    switch (getBreakpoint()) {
      case MediaQuery.sm:
      case MediaQuery.md:
      case MediaQuery.lg:
        this.cardsPerRow = 3;
        break;
      case MediaQuery.xl:
        this.cardsPerRow = 4;
        break;
      case MediaQuery.xxl:
        this.cardsPerRow = 5;
        break;
    }
  }

  handleFilterActions(event: KeyboardEvent): void {
    //preventing page scroll with arrow keys when card controls are selected
    arrowKeysPreventDefault(event);
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_LEFT:
        if (this.activeSlideIndex === 0) {
          SpatialNavigation.resume();
          SpatialNavigation.focus("#" + this.$route.name);
          return;
        }

        this.slideLeft();
        break;
      case KeySet.KEY_RIGHT:
        this.slideRight();
        break;
      case KeySet.KEY_UP:
        SpatialNavigation.resume();
        SpatialNavigation.focus("#" + this.getViewedVodType.replace(/\s/g, ""));
        break;
      case KeySet.KEY_DOWN:
        if (this.activeCategoryVods.length > 0) {
          SpatialNavigation.focus(
            "#" +
              this.getViewedVodType.replace(/\s/g, "") +
              this.activeCategoryVods[0].id +
              0
          );
          this.handleSpatialNavDebounce();
          return;
        }
        SpatialNavigation.resume();
        SpatialNavigation.focus();
        break;
    }
  }

  async getFilteredVodGenres(): Promise<void> {
    this.filteredVodGenres = ["Home"]; //clearing old values
    switch (this.getViewedVodType) {
      case VoDType.Movies:
        this.getMoviesByGenre.forEach((vodGenre) => {
          if (vodGenre.latestMovies && vodGenre.latestMovies.length > 0) {
            this.filteredVodGenres.push(vodGenre.name);
          }
        });
        break;
      case VoDType.TvShows:
        this.getTvShowsByGenre.forEach((vodGenre) => {
          if (vodGenre.latestTvShows && vodGenre.latestTvShows.length > 0) {
            this.filteredVodGenres.push(vodGenre.name);
          }
        });
        break;
    }
  }

  get activeCategoryVods(): TvShow[] | Movie[] {
    switch (this.getViewedVodType) {
      case VoDType.TvShows:
        if (this.activeSlideIndex > 0) {
          for (const genre of this.getTvShowsByGenre) {
            if (genre.name === this.filteredVodGenres[this.activeSlideIndex]) {
              return genre.latestTvShows
                ? genre.latestTvShows.filter((tvShow) => {
                    if (this.searchfilter === "") return true;

                    return tvShow.name
                      .toLowerCase()
                      .includes(this.searchfilter);
                  })
                : [];
            }
          }
        }

        return [];
      case VoDType.Movies:
        if (this.activeSlideIndex > 0) {
          for (const genre of this.getMoviesByGenre) {
            if (genre.name === this.filteredVodGenres[this.activeSlideIndex]) {
              return genre.latestMovies
                ? genre.latestMovies.filter((movie) => {
                    if (this.searchfilter === "") return true;

                    return movie.name.toLowerCase().includes(this.searchfilter);
                  })
                : [];
            }
          }
        }

        return [];
    }

    return [];
  }

  get activeCategoryShownVods(): TvShow[] | Movie[] | undefined {
    if (this.activeCategoryVods) {
      if (this.activeCategoryVods.length > this.cardsToRender) {
        return this.activeCategoryVods.slice(0, this.cardsToRender);
      }
      if (this.activeCategoryVods.length <= this.cardsToRender) {
        return this.activeCategoryVods;
      }
    }

    return undefined;
  }

  lazyLoadCards(vodIndex: number): void {
    if (
      this.activeCategoryShownVods &&
      this.activeCategoryVods &&
      vodIndex >= this.activeCategoryShownVods.length / 2
    ) {
      this.cardsToRender + 15 < this.activeCategoryVods.length
        ? (this.cardsToRender += 15)
        : (this.cardsToRender += this.activeCategoryVods.length - 1);
    }
  }

  handleVodCardRefocus(event: KeyboardEvent, vodIndex: number): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_LEFT:
        SpatialNavigation.resume();
        if (vodIndex % this.cardsPerRow === 0) {
          SpatialNavigation.focus("#" + this.$route.name);
          return;
        }
        SpatialNavigation.focus();
        break;
      case KeySet.KEY_UP:
        if (vodIndex < this.cardsPerRow) {
          SpatialNavigation.focus("#id" + this.activeSlideIndex);
          this.handleSpatialNavDebounce();
          return;
        }
        SpatialNavigation.resume();
        SpatialNavigation.focus();
        break;
      default:
        SpatialNavigation.resume();
        SpatialNavigation.focus();
        break;
    }
  }

  scrollLazyLoad(): void {
    if (
      this.activeCategoryShownVods &&
      this.activeCategoryVods &&
      this.activeSlideIndex !== 0
    ) {
      const triggerIndex = Math.floor(this.activeCategoryShownVods?.length / 2);
      const triggerId =
        this.getViewedVodType + this.activeCategoryShownVods[triggerIndex].id;
      const element = document.getElementById(triggerId);
      if (element) {
        const rect = element.getBoundingClientRect();
        //checking if the VoD card selected is on screen
        if (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        ) {
          this.cardsToRender + 15 < this.activeCategoryVods.length
            ? (this.cardsToRender += 15)
            : (this.cardsToRender += this.activeCategoryVods.length - 1);
        }
      }
    }
  }

  handleSearchFocus(focusStatus: boolean): void {
    this.searchFocused = focusStatus;
    if (this.searchFocused)
      setTimeout(() => {
        SpatialNavigation.focus("#searchInput");
      }, 50);
  }

  @Watch("getViewedVodType")
  async handleVodTypeChange(): Promise<void> {
    await this.getFilteredVodGenres();
    this.genreSwiper?.update();
    this.activeSlideIndex = 0;
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.handleResizeDebounce);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    document
      .getElementById("vodContainer")
      .removeEventListener("scroll", this.scrollLazyLoad);
  }
}
